module.exports = __webpack_public_path__ + "static/media/nocontent.bfa69185.png";